import { createFileRoute, Link, useNavigate } from '@tanstack/react-router'
import { Button } from '@workspace/ui/components/button'
import { ArrowLeft, ChevronRight } from 'lucide-react'
import { useState } from 'react'
import { QueryGuard } from '@/components/query-guard'
import { DeleteUserDialog } from '@/features/admin/components/delete-user-dialog'
import { ProfileView } from '@/features/profile/components/profile-view'
import { useAdminUserByIdQuery } from '@/hooks/api'

export const Route = createFileRoute('/_protected/admin/users/$id')({
  component: AdminUserDetailPage,
})

function AdminUserDetailPage() {
  const { id } = Route.useParams()
  const navigate = useNavigate()
  const userQuery = useAdminUserByIdQuery(id)
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false)

  return (
    <QueryGuard query={userQuery} errorMessage="Failed to load user">
      {(user) => (
        <>
          <nav className="border-b border-border">
            <div className="flex items-center gap-2 py-3">
              <Link
                to="/admin/users"
                className="flex items-center gap-1 text-sm font-medium text-[#f97316] hover:underline"
              >
                <ArrowLeft className="size-4" />
                Users
              </Link>
              <ChevronRight className="size-4 text-muted-foreground" />
              <span className="text-sm font-medium">{user.name || user.email}</span>
            </div>
            <div className="flex gap-1 -mb-px">
              <span className="border-b-2 border-[#f97316] px-3 py-2 text-sm font-medium text-foreground">
                Overview
              </span>
            </div>
          </nav>
          <div className="py-6">
            <ProfileView user={user} canEdit={false} />
          </div>
          <div className="border-t border-border pt-6">
            <div className="rounded-md border border-red-500/20 bg-red-500/5 p-4">
              <h3 className="text-sm font-medium text-red-500">Danger Zone</h3>
              <p className="mt-1 text-sm text-muted-foreground">
                Permanently delete this user and all associated data.
              </p>
              <Button
                variant="destructive"
                size="sm"
                className="mt-3"
                onClick={() => setDeleteDialogOpen(true)}
              >
                Delete User
              </Button>
            </div>
          </div>
          <DeleteUserDialog
            userId={id}
            open={deleteDialogOpen}
            onOpenChange={setDeleteDialogOpen}
            onDeleted={() => navigate({ to: '/admin/users' })}
          />
        </>
      )}
    </QueryGuard>
  )
}
